import { Form, Modal, Select, message } from 'antd';
import React, { FC, useCallback, useState } from 'react';
import { connect } from 'react-redux';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import { patchFieldTechForSupplier } from '../../thunks/field_techs_thunks';
import { contactsRestCrudThunksForSupplierForThirdPartySuppliers } from '../../thunks/contacts_thunks';
import OWAsyncSelect from '../ow_async_select/OWAsyncSelect';

const TARGET_COLLECTION = 'fieldTechSupervisorsDropdown';

const EditSupervisorsModal: FC<any> = ({
	onCancel,
	onSuccess,
	email,
	supervisorEmails: initialSupervisorEmails,
	contacts,
	fetchSupplierUsers,
	patchFieldTech,
}): React.ReactElement => {
	const [form] = Form.useForm();
	const [updating, setUpdating] = useState(false);

	const handleSubmit = useCallback(
		(values) => {
			setUpdating(true);
			patchFieldTech({
				email,
				inventorySupervisorEmails: values.inventorySupervisorEmails || [],
			})
				.then(() => onSuccess && onSuccess())
				.catch(() => message.error('Unable to update supervisors.'))
				.finally(() => setUpdating(false));
		},
		[email, onSuccess, patchFieldTech]
	);

	return (
		<Modal
			visible={true}
			width={600}
			title={'Edit Supervisors'}
			okText={'Save'}
			onCancel={onCancel}
			onOk={form.submit}
			closable={true}
			confirmLoading={updating}
			destroyOnClose={true}
		>
			<Form
				form={form}
				layout="vertical"
				className="supplierForm"
				preserve={false}
				initialValues={{ inventorySupervisorEmails: initialSupervisorEmails || [] }}
				onFinish={handleSubmit}
			>
				<Form.Item label="Supervisors" name="inventorySupervisorEmails">
					<OWAsyncSelect
						mode="multiple"
						stateSlice={contacts}
						valueAccessor={(contact) => contact.email}
						targetCollectionName={TARGET_COLLECTION}
						fetchData={(
							searchText,
							targetCollectionName,
							pagination,
							sorting,
							filters,
							addToTargetCollection
						) => {
							fetchSupplierUsers(
								{ search: searchText && searchText.trim() },
								targetCollectionName,
								pagination,
								sorting,
								filters,
								addToTargetCollection
							);
						}}
						fetchMultiple={(...args) => fetchSupplierUsers(...args)}
						renderRecord={(user) => (
							<Select.Option key={user.email} value={user.email}>
								{nullSafeGet('contact.nameGiven', user)} {nullSafeGet('contact.nameFamily', user)} (
								{nullSafeGet('contact.email', user)})
							</Select.Option>
						)}
						sortBy={{ sort_by: 'name', order: 'ascend' }}
					/>
				</Form.Item>
			</Form>
		</Modal>
	);
};

const mapStateToProps = (state) => ({
	contacts: state.all_contacts,
});

const mapDispatchToProps = (dispatch) => ({
	patchFieldTech: (payload) => dispatch(patchFieldTechForSupplier(payload)),
	fetchSupplierUsers: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			contactsRestCrudThunksForSupplierForThirdPartySuppliers.read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection,
				(data) => data.map((user) => ({ ...user, email: user.id }))
			)
		),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditSupervisorsModal);
